export default __webpack_public_path__ + "static/media/rules_income-bg-desktop.47ed802f.jpg";